import {LabelField, LabelFieldProps} from "@/components/form/LabelField";
import {useFormContext} from "react-hook-form";
import {DestructiveText} from "@/components/ui/form";
import {cn} from "@/lib/utils";
import countries from './countries.json'
import {TextField} from "@/components/form/TextField";
import {ComboboxField} from "@/components/form/ComboboxField";
import {ComponentProps} from "react";

type PhoneFieldProps = Omit<LabelFieldProps, 'name'> & {
    phoneCountryCodeName: string
    phoneName: string
} & Omit<ComponentProps<typeof ComboboxField>,
    'label' |
    'name' |
    'containerClassName' |
    'hideError' |
    'options' |
    'getValue' |
    'getOptionLabel' |
    'getSelectedLabel'>


export function PhoneField({
                               label,
                               phoneCountryCodeName,
                               phoneName,
                               containerClassName,
                               hideError,
                               ...props
                           }: PhoneFieldProps) {
    const form = useFormContext()
    const fieldStatePhoneCountryCodeName = form.getFieldState(phoneCountryCodeName)
    const fieldStatePhoneName = form.getFieldState(phoneName)
    const errorPhoneCountryCodeName = fieldStatePhoneCountryCodeName.error ? String(fieldStatePhoneCountryCodeName.error?.message ?? "") : ""
    const errorPhoneName = fieldStatePhoneName.error ? String(fieldStatePhoneName.error?.message ?? "") : ""
    const error = errorPhoneCountryCodeName === errorPhoneName ? errorPhoneName : [errorPhoneCountryCodeName, errorPhoneName].filter(Boolean).join(" &amp; ")
    return (
        <LabelField label={label} name={phoneCountryCodeName} containerClassName={containerClassName}
                    hideError>
            <div className="w-full">
                <div className="flex w-full">
                    <ComboboxField
                        label={false}
                        name={phoneCountryCodeName}
                        containerClassName={'flex-0'}
                        hideError
                        className={cn('rounded-r-none border-r-0 pr-1', fieldStatePhoneCountryCodeName.invalid && 'border-r-1')}
                        options={countries.map(({dial, code, name}) => ({
                            label: <div className={'flex  w-full'}>
                                <div className={'flex-none w-[60px]'}>
                                    ({dial})
                                </div>
                                <div className={'flex-1 '}>
                                    {name}
                                </div>
                            </div>,
                            value: dial,
                        }))}
                        getValue={(o) => o.value}
                        getOptionLabel={(o) => o.label}
                        getSelectedLabel={(v) => countries.find((o) => o.dial === v)?.dial}
                        {...props}
                    />
                    <TextField
                        label={false}
                        name={phoneName}
                        containerClassName={'flex-1'}
                        hideError
                        className={cn('pl-1 rounded-l-none border-l-0', !fieldStatePhoneCountryCodeName.invalid && fieldStatePhoneName.invalid && 'border-l-1')}/>

                </div>
                {!hideError && error && <DestructiveText>
                    {error}
                </DestructiveText>}
            </div>
        </LabelField>
    )
}

PhoneField.displayName = "PhoneField";

